import React from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
//@ts-ignore
import LKPeriodButton from 'shared/LKPeriodButton'
import { reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { Segment, Grid, Button } from 'semantic-ui-react'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import FormField from 'shared/newFormElements'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer, GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
import withLivedata from '../../shared/containers/withLivedata'
import { constants as DCConstants, actions as DCActions } from '../../DetailsContainer'
import { formName, ENTRIES_FORM_NAME } from '../constants'
import { translateCmd, translateBase, icon, translateWebMessages } from '../helpers'
import { withConstantPermissions } from '../../shared'
import { EntriesProps, EntryData } from '../types'
import { AppDispatch } from 'src/store/index.d'

const config = {
  gridIdentity: {
    formName,
    objectName: 'dbgrd_entries',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableSorting: true,
  enableRowSelection: true,

  columnConfigs: {
    Amount: {
      cellStyle: { textAlign: 'right' },
    },
    DocDate: {
      valueFormatter: ({ value }: { value: string }) => dateFormatter(value),
    },
  },
}

@withRouter
//@ts-ignore
@withLivedata(['OpenDayStatus.Open_Day_Str as openDay', 'OpenDayStatus.Open_Day as openDayDate'])
//@ts-ignore
@withConstantPermissions('ACC_ENTRIES_VIEW as CanViewEntries')
//@ts-ignore
@connect(
  (_state, { openDay, ID }: { openDay: string; ID: string }) => ({
    form: ENTRIES_FORM_NAME + ID,
    initialValues: { StartDate: openDay, EndDate: openDay },
  }),

  //@ts-ignore
  (dispatch, { openDayDate, ID }) => ({
    setDateFiltersToOperDay: () => {
      const formated = moment(openDayDate).format('DD.MM.YYYY')

      dispatch(change(ENTRIES_FORM_NAME + ID, 'StartDate', formated))
      dispatch(change(ENTRIES_FORM_NAME + ID, 'EndDate', formated))
    },
  }),
)
//@ts-ignore
@reduxForm({
  destroyOnUnmount: false,
  validate: (values: { StartDate: string; EndDate: string }) => {
    const errors: {
      StartDate?: string
      EndDate?: string
    } = {}

    if (!LKDate.isValid(values.StartDate) || LKDate.from(values.StartDate) > LKDate.from(values.EndDate)) {
      errors.StartDate = translateWebMessages('INVALID_DATE')
    }

    if (!LKDate.isValid(values.EndDate) || LKDate.from(values.EndDate) < LKDate.from(values.StartDate)) {
      errors.EndDate = translateWebMessages('INVALID_DATE')
    }

    return errors
  },
  onSubmit: (
    data: {
      StartDate: string
      EndDate: string
    },
    dispatch: AppDispatch,
    {
      ID,
      hash,
    }: {
      ID: string
      hash: string
    },
  ) => {
    dispatch(DCActions.fetchPage({ type: 'Client', ID, hash, page: 'entries', additionalParams: data }))
  },
})
class Entries extends React.Component<EntriesProps> {
  onRowDoubleClicked = ({ node: { data } }) => {
    if (this.props.CanViewEntries) {
      this.pushDetailsRoute(data)
    }
  }

  getContextMenuItems = (params: { node: { data: EntryData } }) => {
    const {
      node: { data },
    } = params
    const { CanViewEntries } = this.props

    return [
      CanViewEntries && data.HashSum_EntryID_
        ? {
            name: translateCmd('entry_details'),
            action: () => this.pushDetailsRoute(data),
            icon: 'info',
          }
        : undefined,
      'excelExport',
    ].filter(Boolean)
  }

  pushDetailsRoute = ({ OperTypeID, ID, HashSum_EntryID_, OID, HashSum_OID_ }: EntryData) => {
    let route: string

    if (OperTypeID === 6 || OperTypeID === 7) {
      route = `/secure/order/${ID}/details/${HashSum_EntryID_}/${OperTypeID}/${OID}/${HashSum_OID_}`
    } else {
      route = `/secure/order/${ID}/details/${HashSum_EntryID_}/${OperTypeID}`
    }

    this.props.history.push(route)
  }

  render() {
    const { data, ID, setDateFiltersToOperDay, handleSubmit, change: formChange } = this.props
    const gridInstanceName = `${DCConstants.DetailsGridPrefixes.client}-${ID}-Entries`

    return (
      <SegmentGroup>
        <Segment.Group>
          <FlexTableChild>
            <TableContainer>
              <LKGrid
                rowData={data}
                {...config}
                instanceName={gridInstanceName}
                onRowDoubleClicked={this.onRowDoubleClicked}
                getContextMenuItems={this.getContextMenuItems}
              />
            </TableContainer>
          </FlexTableChild>

          <Segment>
            <form onSubmit={handleSubmit}>
              <GridContainer>
                <Grid>
                  <Grid.Row>
                    <Grid.Column className="u-flex" width={5}>
                      <div className="u-fluid">
                        <FormField type="range-date-picker-first-input" name="StartDate" />
                      </div>

                      <Button.Group className="u-marginLeft-5 u-marginRight-5">
                        <LKPeriodButton startDateName="StartDate" endDateName="EndDate" change={formChange} />

                        <LKButton onClick={setDateFiltersToOperDay} alias="today" />
                      </Button.Group>

                      <div className="u-fluid">
                        <FormField
                          upward
                          form={ENTRIES_FORM_NAME + ID}
                          startDateName="StartDate"
                          endDateName="EndDate"
                          type="range-date-picker"
                        />
                      </div>
                    </Grid.Column>

                    <Grid.Column className="u-flex" textAlign="left" width={4}>
                      <LKButton alias="refresh" size="tiny" isSubmit>
                        {translateCmd('refresh_entries')}
                      </LKButton>

                      <LKGridExportButton alias="export" size="tiny" instanceName={gridInstanceName} />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </GridContainer>
            </form>
          </Segment>
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

//@ts-ignore
Entries.config = {
  title: () => translateBase('tb_entries'),
  name: 'entries',
  component: Entries,
  api: {
    page: 'entries',
    fetchOnInit: false,
  },
  icon: icon('tb_entries'),
}

//@ts-ignore
Entries.defaultProps = {
  data: [],
}

export default Entries
